import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import Tooltip, { THEME, POSITION } from '@mos-cat/tooltip';
import AddToFavoriteIcon from '../../assets/AddToFavorite.svg';
import RemoveFromFavoriteIcon from '../../assets/RemoveFromFavorite.svg';

import {
  loadServiceFavouriteStatus,
  changeServiceFavoriteStatus
} from '../../store/favorite/actions';
import {
  FavoritePropTypes,
  FavoriteStructuredSelector
} from './favoriteSelector';

import './Favorite.pcss';

const Favorite = ({
  inFavorite,
  handleLoadServiceFavouriteStatus,
  handleChangeServiceFavoriteStatus
}) => {
  const [tooltipIsVisible, setTooltipIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleChange = () => {
    setIsLoading(false);
    handleChangeServiceFavoriteStatus();
  };

  useEffect(() => {
    handleLoadServiceFavouriteStatus();
  }, []);

  useEffect(() => {
    if (inFavorite && !isLoading) {
      setTooltipIsVisible(true);

      setTimeout(() => {
        setTooltipIsVisible(false);
      }, 1200);
    }

    return () => {
      setIsLoading(false);
      setTooltipIsVisible(false);
    };
  }, [inFavorite]);

  return (
    <Tooltip
      className="Favorite__tooltip"
      wrapperClassName="Favorite__tooltip-wrapper"
      theme={THEME.INFO}
      open={tooltipIsVisible}
      position={POSITION.bottom}
      content="Добавлено в Личный кабинет"
      appearanceDuration={200}
    >
      <button className="Favorite__button" type="button" onClick={handleChange}>
        {inFavorite ? <RemoveFromFavoriteIcon /> : <AddToFavoriteIcon />}
        <span className="Favorite__button-text">
          {inFavorite ? 'Добавлено ' : 'Добавить '}в избранное
        </span>
      </button>
    </Tooltip>
  );
};

Favorite.propTypes = {
  ...FavoritePropTypes
};

const mapDispatchToProps = dispatch => ({
  handleLoadServiceFavouriteStatus: () =>
    dispatch(loadServiceFavouriteStatus()),
  handleChangeServiceFavoriteStatus: () =>
    dispatch(changeServiceFavoriteStatus())
});

export default connect(
  FavoriteStructuredSelector,
  mapDispatchToProps
)(Favorite);
